var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPaper2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6H6.75M3.25 8.33333H6.75M7.91667 11.25H2.08333C1.439 11.25 0.916666 10.7277 0.916666 10.0833V1.91667C0.916666 1.27233 1.439 0.75 2.08333 0.75H5.34171C5.49642 0.75 5.64479 0.811458 5.75419 0.920854L8.91248 4.07915C9.02188 4.18854 9.08333 4.33691 9.08333 4.49162V10.0833C9.08333 10.7277 8.561 11.25 7.91667 11.25Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPaper2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/paper2.7fa95a44.svg";
export { ForwardRef as ReactComponent };